import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonList, IonLoading, IonModal, IonPage, IonRow, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { add, arrowBack, listOutline, trashOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { empresaAlterar, empresaCarregar, removerFormularioCategoriaEmpresa, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import '../ConfiguracoesLayout.css';

type Props = {
  abrirMenu: boolean;
  projetoid: string;
  empresaid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const FormularioCategorias: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaCategoriaFormulario, setListaCategoriaFormulario] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const inputRef = useRef<any>(null);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
    if (inputRef.current) {
      inputRef.current.setFocus();
    }
  });


  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setListaCategoriaFormulario(response.Item.categoriaFormulario || []);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }



  function deletarCategoria(nome: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delCategoria = async () => {
      const resp = await fetch(removerFormularioCategoriaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerFormularioCategoriaEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'nome': nome }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno", retorno);
      setTextToast("Categoria removida com sucesso.");
      setShowToast(true);
      carregarConta();
    }

    delCategoria();

  }

  const loadCategoriaFormulario = () => {
    if (listaCategoriaFormulario == undefined) return;
    if (listaCategoriaFormulario.length === 0) return <div className="config-empty"><IonIcon icon={listOutline} aria-hidden="true" /><h2>Nenhuma categoria cadastrada</h2><p>Adicione uma categoria para organizar as perguntas do formulário.</p></div>;
    return listaCategoriaFormulario.map((value: any, index: any) => <div className="config-category-row" key={index}>
      <span className="config-category-name"><IonIcon icon={listOutline} aria-hidden="true" /><strong>{value}</strong></span>
      <IonButton fill="clear" className="config-delete" aria-label={`Excluir categoria ${value}`} onClick={() => { deletarCategoria(value) }}><IonIcon slot="icon-only" icon={trashOutline} /></IonButton>
    </div>);
  }

  function cadastrar() {
    const objectRequest = {
      nome: nome
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    requestService(
      empresaAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?formulariocategoria=sim"),
      {
        method: empresaAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          carregarConta();
          setShowDetalhes(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })
  }

  return (

    <IonPage className="config-layout-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="config-layout-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Categorias do Formulário</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="config-layout-content" fullscreen={false}>
<IonFab className="config-mobile-add" vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}><IonFabButton aria-label="Nova categoria" onClick={() => {
                  setNome("");
                  setShowDetalhes(true);
                }}><IonIcon icon={add} aria-hidden="true" /></IonFabButton></IonFab><div className="config-container config-list-container"><header className="config-heading"><div><h1>Categorias do formulário</h1><p>Organize as categorias usadas nas perguntas do formulário.</p></div><IonButton className="config-primary config-desktop-add" hidden={acessos?.configuracoes != 'edicao'} onClick={() => {
                  setNome("");
                  setShowDetalhes(true);
                }}><IonIcon slot="start" icon={add} />Nova categoria</IonButton></header>

<section className="config-grid-card"><div className="config-grid-heading"><h2>Categorias cadastradas</h2><p>{listaCategoriaFormulario.length} {listaCategoriaFormulario.length === 1 ? "categoria cadastrada" : "categorias cadastradas"}</p></div><div className="config-category-head" hidden={listaCategoriaFormulario.length === 0}><span>Categoria</span><span>Ações</span></div>{loadCategoriaFormulario()}</section></div>
        <IonModal className="config-modal config-category-modal" onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setNome("");
        }}>


          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>Nova categoria</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="config-layout-content">
              <IonGrid className="config-modal-grid">
                <IonRow>
                  <IonCol>
                    <IonList className="config-modal-fields">

                      <div className="config-field">
                        <span className="config-label">Nome*</span>
                        <IonInput aria-label="Nome da categoria" placeholder="Digite o nome da categoria" value={nome} ref={(ref) => inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
                      </div>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonGrid>

            </IonContent>
            <IonFooter className="ion-no-border config-footer">
              <div className="config-footer-actions">
                <button className="config-save" onClick={() => cadastrar()} type="submit">Cadastrar</button>
              </div>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default FormularioCategorias;
